import { render, staticRenderFns } from "./CarnetSaillie.vue?vue&type=template&id=96e2c2ee&"
import script from "./CarnetSaillie.vue?vue&type=script&lang=js&"
export * from "./CarnetSaillie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports